/** @format */

import React, { useRef, useState, useMemo, useEffect } from "react";
import AccordionLoader from "../common/AccordionLoader";
import { AgGridReact } from "ag-grid-react";
// import Navbar from "../Navbar";
import "../../style/merchantContacts.css";
// import { FileUpload } from 'primereact/fileupload';
import service from "../../utils/service";
import * as XLSX from "xlsx";
import { Toast } from "primereact/toast";
// import { Button } from 'primereact/button';
import { FileUpload } from "./FileUpload";
// import { GridApi } from "ag-grid-community";
// import { GridApi } from "ag-grid-community";
// import partition from 'lodash.partition';
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";

const UploadMerchantContacts = (props) => {
  const fileUploadRef = useRef(null);
  const toastRef = useRef(null);
  const gridRef = useRef(null);
  const [rowData, setRowData] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  // const [gridColumnApi, setGridColumnApi] = useState(null);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Region",
        field: "region",
      },
      {
        headerName: "Country",
        field: "country",
      },
      { headerName: "Merchant Name", field: "merchantName" },
      { headerName: "Phone Number", field: "phoneNumber" },
      { headerName: "E-mail Address", field: "email" },
    ],
    []
  );

  const defaultColDefs = useMemo(
    () => ({
      flex: 1,
      resizable: true,
    }),
    []
  );

  const onGridReady = (params) => {
    params.api.showLoadingOverlay();
    setGridApi(params.api);
  };

  const getChannelMerchants = () => {
    return service
      .getChannelMerchants()
      .then((res) => {
        setRowData(res.data.filter((d) => d.channelId === props.channel.channelId));
      })
      .catch(err => {
      toastRef.current.show({severity:'error', summary: 'Error', detail:`Error Retrieving Merchant Contacts ${err.error}`, life: 3000})
    });
  }

  const saveChannelMerchants = (merchant_contacts) => {
    if (gridApi) {
      gridApi.showLoadingOverlay();
    }
    return service
      .createChannelMerchants(merchant_contacts)
      .then((val) => {
        toastRef.current.show({
          severity: "success",
          summary: "Success",
          detail: "Successfully Uploaded Merchant Contacts",
          life: 3000,
        });
        getChannelMerchants()
          .then(() => {
            if (gridApi) {
              gridApi.hideOverlay();
            }
          })
          .catch((err) => {
            if (gridApi) {
              gridApi.hideOverlay();
            }
          });
      })
      .catch((err) => {
        const errMessage = err.response && err.response?.data?.message?.match(/\[.*?\]/g);
        let errMessageToDisplay = "";
        if (errMessage) {
          errMessageToDisplay = errMessage.length === 2 ? errMessage[1] : errMessage[0];
        }
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: `Error uploading Merchant contacts. ${errMessageToDisplay}`,
          life: 3000,
        });
        if (gridApi) {
          gridApi.hideOverlay();
        }
      });
  };

  useEffect(() => {
    service
      .getChannelMerchants()
      .then((res) => {
        setRowData(res.data.filter((d) => d.channelId === props.channel.channelId));
      })
      .catch(err => {
      gridRef.current.api.hideOverlay();
      toastRef.current.show({severity:'error', summary: 'Error', detail:`Error Retrieving Merchant Contacts ${err.error}`, life: 3000})
    });    
    return () => setRowData(null)
  }, [props.channel.channelId])

  const uploadFile = (e) => {
    let regionMap = new Map();
    let countryMap = new Map();
    props.regionAndCountries.availableChannels.forEach((channel) => {
      channel.regions.forEach((region) => {
        regionMap.set(region.region, region.regionId);
      });
    });
    // e.stopPropagation(); e.preventDefault();
    var f = e.files[0];
    /* f is a File */
    var reader = new FileReader();
    reader.onload = function (e) {
      var data = e.target.result;
      /* reader.readAsArrayBuffer(file) -> data will be an ArrayBuffer */
      var workbook = XLSX.read(data);
      workbook.SheetNames.forEach((sheetname) => {
        const sheetData = workbook.Sheets[sheetname];
        let MERCHANTS_CONTACTS = XLSX.utils.sheet_to_json(sheetData);
        const SHEET_KEYS = ["Merchant name", "Phone number", "E-mail adress", "Region", "Country"];
        const merchant_sheetKeys = MERCHANTS_CONTACTS[0] && Object.keys(MERCHANTS_CONTACTS[0]);
        const validKeys =
          merchant_sheetKeys &&
          merchant_sheetKeys.length === SHEET_KEYS.length &&
          SHEET_KEYS.every((key) => merchant_sheetKeys.includes(key));

        if (validKeys) {
          MERCHANTS_CONTACTS = MERCHANTS_CONTACTS.map((data) => {
            let countryId = "";
            const COUNTRY_WITH_ID = props.regionAndCountries.countries.find((country) => {
              if (data.Country && data.Country.length === 2 && data.Country === "UK") {
                return country.countryName.toLowerCase() === "united kingdom(uk)";
              }
              return data.Country && country.countryName.toLowerCase() === data.Country.toLowerCase();
            });
            if (COUNTRY_WITH_ID) {
              const countryName = COUNTRY_WITH_ID.countryName.toLowerCase();
              if (countryMap.has(countryName)) {
                countryId = countryMap.get(countryName);
              } else {
                countryMap.set(countryName, COUNTRY_WITH_ID.countryId);
                countryId = COUNTRY_WITH_ID.countryId;
              }
            }
            return {
              channelId: props.channel.channelId,
              merchantName: data["Merchant name"],
              phoneNumber: data["Phone number"],
              region: data.Region,
              regionId: regionMap.get(data.Region),
              country: data.Country,
              countryId,
              email: data["E-mail adress"]
            }
          })
          // const [validContacts, inValidContacts] = partition(MERCHANTS_CONTACTS, contact => contact.countryId !== '');
          saveChannelMerchants(MERCHANTS_CONTACTS);
        } else {
          toastRef.current.show({severity:'error', summary: 'Error', detail:`Please upload excel with the following headers ${SHEET_KEYS.join(', ')}`, life: 3000});
        }
        fileUploadRef.current.clear();
      });
      /* DO SOMETHING WITH workbook HERE */
    };
    reader.readAsArrayBuffer(f);
  };

  return (
    <>
      <div id='merchant_contact' style={{ display: "flex" }}>
        <Toast ref={toastRef} baseZIndex={20000} />
        <div style={{ flex: "1" }}></div>
        <FileUpload
          className='mb-3'
          ref={fileUploadRef}
          name='file'
          accept='.xlsx'
          multiple={false}
          uploadHandler={uploadFile}
        />
      </div>
      <div
        className='ag-theme-alpine-dark'
        // style={{ height: 'calc(100vh - 80px - 1rem)', width: "100%" }}
        style={{ height: `calc(100vh - 310px)`, width: "100%", marginBottom: "1rem" }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          skipHeaderOnAutoSize={true}
          // frameworkComponents={components}
          columnDefs={columnDefs}
          // domLayout="autoHeight"
          // getRowStyle={getRowStyle}
          defaultColDef={defaultColDefs}
          colResizeDefault={"shift"}
          onGridReady={onGridReady}
          // onFirstDataRendered={() => autoSizeAll(false)}
          suppressColumnVirtualisation='true'
          pagination={true}
          paginationPageSize={10}
          paginationAutoPageSize={true}
          overlayNoRowsTemplate='<span style="color: #cccccc">No Rows to Show</span>'
          overlayLoadingTemplate='<span class="ag-overlay-loading-center">Please wait..</span>'
          // headerHeight = {headerHeight}
        />
      </div>
    </>
  );
};

function MerchantContacts(props) {
  const [editIndex, setEditIndex] = useState(-1);
  const [channelIndex, setChannelIndex] = useState(-1);
  const [regionAndCountries, setRegionAndCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isGrainsRole, isSuperAdminRole, isCornRole } = props;
  useEffect(() => {
    service
      .getRegionCountry()
      .then((res) => {
        setRegionAndCountries(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("err", err);
        setLoading(false);
      });
  }, []);
  const mapping = (
    <div style={{ marginTop: "1.5rem" }}>
      {loading && <AccordionLoader />}
      {regionAndCountries?.availableChannels?.map((channel, index) => {
        let isChannelDisabled = false;
        if (channel.channelName === BUSINESS_UNIT.ANIMAL_FEED && !isSuperAdminRole && !isAnimalFeedRole) {
          isChannelDisabled = true;
        }
        if (channel.channelName === BUSINESS_UNIT.EDIBLE_OILS && !isSuperAdminRole && !isEdibleOilsRole) {
          isChannelDisabled = true;
        }
        if (channel.channelName === BUSINESS_UNIT.GRAINS && !isSuperAdminRole && !isGrainsRole) {
          isChannelDisabled = true;
        }
        if (channel.channelName === BUSINESS_UNIT.COCOA && !isSuperAdminRole && !isCocoaRole) {
          isChannelDisabled = true;
        }
        if (channel.channelName === BUSINESS_UNIT.CORN && !isSuperAdminRole && !isCornRole) {
          isChannelDisabled = true;
        }        
        return (
          <div className='grid' key={index}>
            <div className='col-fixed' style={{ width: "80px" }}>
              <div style={{ opacity: isChannelDisabled ? "0.5" : "1" }} className='box1 text-center'>
                {index + 1}
              </div>
            </div>
            <div className='col'>
              <div className='box' style={{ opacity: isChannelDisabled ? "0.5" : "1" }}>
                {channel.channelName}
                <span
                  onClick={(e) => {
                    if (isChannelDisabled) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                    if (channelIndex === index) {
                      setChannelIndex(-1);
                      setEditIndex(-1);
                    } else {
                      setEditIndex(-1);
                      setChannelIndex(index);
                    }
                  }}
                  className='floatRight'
                >
                  {channelIndex === index ? (
                    <i className='pi pi-chevron-up'></i>
                  ) : (
                    <i className='pi pi-chevron-down'></i>
                  )}
                </span>

                {channelIndex === index && editIndex === -1 && (
                  <div className='seperatorContent'>
                    <UploadMerchantContacts regionAndCountries={regionAndCountries} channel={channel} />
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
  return <div>{mapping}</div>;
}

export default MerchantContacts;
